import { HttpInterceptorFn } from '@angular/common/http';
import * as _ from 'lodash';

export const formDataInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.headers.get('content-type') !== 'multipart/form-data') {
    return next(req);
  }

  return next(req.clone({ headers: req.headers.delete('Content-Type'), body: toFormData(req.body) }));
};

function toFormData(input: any): FormData {
  // Clone so we never mutate the caller's request body. File leaves are kept by reference
  // (customizer returns them as-is) — important because the auth interceptor may re-run this
  // interceptor on the same body when retrying after a token refresh.
  const raw = _.cloneDeepWith(input, (value: unknown) => (value instanceof File ? value : undefined));
  const leafs = paths(raw, '');
  const files: File[] = [];
  leafs.forEach(f => {
    const fi = _.at(raw, f)[0];
    if (fi instanceof File) {
      files.push(fi);
      _.set(raw, f, '');
    }
  });
  const fd = new FormData();
  fd.append('data', JSON.stringify(raw));
  files.forEach(f => {
    fd.append('file', f);
  });

  return fd;
}

function paths(obj: any, parentKey: string): string[] {
  let result: string[];
  if (_.isArray(obj)) {
    let idx = 0;
    result = _.flatMap(obj, function (r) {
      return paths(r, (parentKey || '') + '[' + idx++ + ']');
    });
  } else if (_.isPlainObject(obj)) {
    const record: Record<string, any> = obj;
    result = _.flatMap(_.keys(record), function (key) {
      return _.map(paths(record[key], key), function (subkey) {
        return (parentKey ? parentKey + '.' : '') + subkey;
      });
    });
  } else {
    result = [];
  }

  return _.concat(result, parentKey || []);
}
